import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { Grid } from "../Grid";
import { IconButton } from "../IconButton";
import { Typography } from "../Typography";
import { StyledAppBar } from "./styled";
import { IAppBarProps } from "./types";
import { Box } from "@mui/material";

const AppBar = ({children, brandName, icon, badgeText, onMenuClick, ...props}: IAppBarProps)=>(
    <StyledAppBar {...props} elevation={0}>
        <Grid container gap={2} sx={{ flex: 1 }}>
            <Grid item>
                <Grid container gap={1} alignItems="center">
                    {onMenuClick && (
                        <IconButton variant="clean" color="neutral" onClick={onMenuClick} aria-label="Abrir menu">
                            <MenuOutlinedIcon />
                        </IconButton>
                    )}
                    {icon}
                    <Typography
                        variant="h1"
                        sx={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        {brandName}
                    </Typography>
                    {badgeText && (
                        <Typography
                            variant="h1"
                            sx={{
                                color: "accentWarning.main",
                                whiteSpace: 'nowrap',
                                display: { xs: 'none', md: 'block' },
                            }}
                        >
                            {badgeText}
                        </Typography>
                    )}
                </Grid>
            </Grid>
        </Grid>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1}}>
            {children}
        </Box>
    </StyledAppBar>
)

export {AppBar}